var React = require('react');

function Mail (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.00008 0H14.0001C14.7365 0 15.3334 0.596954 15.3334 1.33333V10.6667C15.3334 11.403 14.7365 12 14.0001 12H2.00008C1.2637 12 0.666748 11.403 0.666748 10.6667V1.33333C0.666748 0.596954 1.2637 0 2.00008 0ZM2.00008 4.41211V10.6667H14.0001V4.41239L8.00006 7.4124L2.00008 4.41211ZM2.00008 2.92137L8.00009 5.92167L14.0001 2.92168V1.33333H2.00008V2.92137Z","fill":"currentColor"}));
}

Mail.defaultProps = {"viewBox":"0 0 16 12","fill":"none"};

module.exports = Mail;

Mail.default = Mail;
